<template lang="pug">
  nuxt-child
</template>

<script>
export default {
  scrollToTop: true,
  layout: 'base'
};
</script>
